import { BaseComponent } from 'components/BaseComponent';
import { Button } from 'components/Buttons';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { logout, fetchMe } from '../../Api/actions';
import { selectApiKey } from '../../Api/selectors';

// in dev mode we don't redirect on false api key
const Container = styled.div`
  text-align: center;
`;

/* eslint-disable react/prefer-stateless-function */
class AccountPageComp extends BaseComponent {
  componentDidMount() {
    this.props.get();
  }

  render() {
    return (
      <Container>
        <h3>Account</h3>

        <Button onClick={this.tofn('/logout')}>Logout</Button>
        <p>{window.navigator.userAgent}</p>
      </Container>
    );
  }
}

AccountPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    apiKey: selectApiKey(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get() {
      dispatch(fetchMe());
    },
    logout() {
      dispatch(logout());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const AccountPage = compose(
  withRouter,
  withConnect,
)(AccountPageComp);
